import { Typography } from '@mui/material';

import Number from 'src/components/common/Number';
import { gt } from 'src/utils/number';

import { AmountInfoColumnContainer, Base02TextContainer, Container, IconContainer, LeftContainer, TokenInfoColumnContainer } from './styled';

type TokenItemProps = {
  icon?: React.ReactNode;
  tokenName: string;
  subText: string;
  amount?: string;
  // price?: string;
};

export default function TokenItem({ icon, tokenName, subText, amount }: TokenItemProps) {
  return (
    <Container>
      <LeftContainer>
        <IconContainer>{icon}</IconContainer>

        <TokenInfoColumnContainer>
          <Typography variant="h4">{tokenName}</Typography>

          <Base02TextContainer>
            <Typography variant="h9">{subText}</Typography>
          </Base02TextContainer>
        </TokenInfoColumnContainer>
      </LeftContainer>

      <AmountInfoColumnContainer>
        {gt(amount || '0', '0') ? (
          <Number typoOfIntegers="h4" typoOfDecimals="h6">
            {amount}
          </Number>
        ) : (
          <Typography variant="h4">0</Typography>
        )}

        {/* <Base02TextContainer>
          <Typography variant="h8">$</Typography>
          &nbsp;
          {gt(price || '0', '0') ? (
            <Number typoOfIntegers="h8" typoOfDecimals="h10">
              {price}
            </Number>
          ) : (
            <Number typoOfIntegers="h8" typoOfDecimals="h10">
              0.000
            </Number>
          )}
        </Base02TextContainer> */}
      </AmountInfoColumnContainer>
    </Container>
  );
}
